import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPalette = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.329 3c2.538.006 5.118.832 6.784 2.831 1.646 1.973 2.496 5.21.932 7.465-.994 1.434-2.675 2.145-4.364 2.334-1.67.188-2.27 1.296-1.535 2.94.541 1.21.011 2.291-1.506 2.406-5.523.418-10.22-4.754-9.425-10.247C3.898 6.01 7.523 2.99 12.33 3"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.203 7.44v.054m.217-.042a.218.218 0 1 1-.436 0 .218.218 0 0 1 .436 0M13.82 6.349v.053m.217-.042a.218.218 0 1 1-.436 0 .218.218 0 0 1 .436 0M17.342 9.976v.053m.216-.042a.218.218 0 1 1-.435 0 .218.218 0 0 1 .435 0M6.658 11.544v.053m.217-.041a.218.218 0 1 1-.436 0 .218.218 0 0 1 .436 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPalette);
export default ForwardRef;
